import addCheckpointHelper from '../history/add-checkpoint';

const addCheckpoint = () => addCheckpointHelper();

export default addCheckpoint;
